import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FiArrowLeft, FiFileText, FiSend } from "react-icons/fi";
import Navbar from '../../../Shared/ManagerNavbar/Navbar';
import { pdf } from "@react-pdf/renderer"; 
import axios from "axios";
import baseURL from "../../../Apiurs/Apiurls";
import InvoicePDF from "../../Admin/Tharun/Pdf2";

// Currency formatting
const formatCurrency = (amount) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 2,
  }).format(amount);

const Previewquotationpage = () => {
  const { id } = useParams(); // get id from URL
  const navigate = useNavigate();

  const [collapsed, setCollapsed] = useState(false);
  const [leadInfo, setLeadInfo] = useState(null);
  const [data, setData] = useState(null);
  const [quotationData, setQuotationData] = useState([]);
  const [sendingQuotation, setSendingQuotation] = useState(false);
  const [quotationStatus, setQuotationStatus] = useState("");
  const [quotationNumber, setQuotationNumber] = useState("");
  const [discount, setDiscount] = useState(0);
  const [discountType, setDiscountType] = useState("percentage");

  // Fetch quotation by id
  useEffect(() => {
    if (!id) return;

    const fetchQuotation = async () => {
      try {
        const res = await axios.get(`${baseURL}/api/quotations/${id}`);

        const quotation = res.data;
          console.log("quotation",quotation);

        setLeadInfo((prev) => ({
          ...prev,
          quotation_number: quotation.quotation_number || quotationNumber,
        }));
console.log("quotation_number", quotation.quotation_number);
        setData({
          subtotal: quotation.subtotal,
          totalGST: quotation.gst,
          grandTotal: quotation.total_amount,
          quotationDate: new Date(quotation.created_at).toLocaleDateString(),
        });

        // Parse products JSON string dynamically
        let productsArray = [];
        try {
          productsArray = quotation.products ? JSON.parse(quotation.products) : [];
        } catch (err) {
          console.error("Failed to parse products JSON:", err);
        }
        setQuotationData(productsArray);
      } catch (err) {
        console.error("Failed to fetch quotation:", err);
        alert("Failed to load quotation.");
      }
    };

    fetchQuotation();
  }, [id, quotationNumber]);

  // Fetch next quotation number
  useEffect(() => {
    const fetchNextNumber = async () => {
      try {
        const res = await axios.get(`${baseURL}/api/get-next-quotation-number`);
        if (res.data.quotationNumber) setQuotationNumber(res.data.quotationNumber);
      } catch (err) {
        console.error("Error fetching next quotation number:", err);
      }
    };
    fetchNextNumber();
  }, []);

  // Fetch discount
  useEffect(() => {
    if (!id) return;
    const fetchDiscount = async () => {
      try {
        const res = await axios.get(`${baseURL}/api/lead/${id}/discount`);
        if (res.data.success) {
          setDiscount(res.data.discount || 0);
          setDiscountType(res.data.discountType || "percentage");
        }
      } catch (err) {
        console.error("Error fetching discount:", err);
      }
    };
    fetchDiscount();
  }, [id]);

  // Fetch quotation status
  useEffect(() => {
    if (!id) return;
    const fetchStatus = async () => {
      try {
        const res = await axios.get(`${baseURL}/api/lead-quotation-status/${id}`);
        if (res.status === 200) setQuotationStatus(res.data.quotation_status || "");
      } catch (err) {
        console.error("Error fetching quotation status:", err);
      }
    };
    fetchStatus();
  }, [id]);

  // Fetch lead info (Bill To & Terms)
  useEffect(() => {
    if (!id) return;

    const fetchLead = async () => {
      try {
        const res = await axios.get(`${baseURL}/api/emaileads/${id}`);
        if (res.data.success && res.data.data) {
          const lead = res.data.data;
          console.log("lead",lead);
          setLeadInfo((prev) => ({
            
            ...prev,
            lead_name: lead.lead_name,
            contact_number: lead.contact_number,
            email: lead.email,
            terms_conditions: lead.terms_conditions,
            lead_source: lead.lead_source,
          }));
        } else {
          alert("Lead not found.");
        }
      } catch (err) {
        console.error("Failed to fetch lead:", err);
        alert("Failed to load lead info.");
      }
    };

    fetchLead();
  }, [id]);

  // PDF Preview handler
const handlePDFPreview = async () => {
  if (!leadInfo || !data) return;

  const today = new Date();
  const dateString = today.toISOString().split("T")[0];

  console.log("Quotation Number (from leadInfo):", leadInfo.quotation_number); // ✅ log here
  console.log("Lead Info being sent:", leadInfo);
  console.log("Data being sent:", data);
  console.log("Quotation Data being sent:", quotationData);

  try {
const blob = await pdf(
  <InvoicePDF
    data={data}  // ✅ Pass full data object (has subtotal, totalGST, etc.)
    quotationNumber={leadInfo.quotation_number}  // ✅ Pass separately from leadInfo
    leadInfo={leadInfo}
    quotationData={quotationData}  // ✅ Now properly used
    discount={discount}  // ✅ Added for TermsConditions page
    discountType={discountType}  // ✅ Added for TermsConditions page
  />
).toBlob();

    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  } catch (err) {
    console.error("Error generating PDF preview:", err);
    alert("Failed to generate PDF preview. Please try again.");
  }
};


  // Send quotation handler
  const handleGenerateQuotation = async () => {
    if (!leadInfo || !data) return;
    setSendingQuotation(true);
    const today = new Date();
    const dateString = today.toISOString().split("T")[0];

    try {
      const blob = await pdf(
        <InvoicePDF
          data={{
            quotationNumber: leadInfo.quotation_number,
            quotationDate: dateString,
            subtotal: data.subtotal,
            totalGST: data.totalGST,
            grandTotal: data.grandTotal,
          }}
          leadInfo={leadInfo}
          quotationData={quotationData}
        />
      ).toBlob();

      const formData = new FormData();
      formData.append("pdf", blob, `${leadInfo.quotation_number}.pdf`);
      formData.append("email", leadInfo.email);
      formData.append("name", leadInfo.lead_name);
      formData.append("id", id);
      formData.append("quotationNumber", leadInfo.quotation_number);
      formData.append("quotationDate", dateString);
      formData.append("gst", String(data.totalGST));
      formData.append("total_amount", String(data.grandTotal));
      formData.append("subtotal", String(data.subtotal));
      formData.append("products", JSON.stringify(quotationData));
      formData.append("message_id", leadInfo.message_id || "");

      const sendRes = await fetch(`${baseURL}/api/send-quotation`, {
        method: "POST",
        body: formData,
      });
      const sendData = await sendRes.json();

      if (!sendRes.ok || !sendData.success) {
        console.error("Send quotation failed:", sendData);
        alert("Failed to send quotation. Server returned an error.");
        return;
      }

      const statusRes = await fetch(`${baseURL}/api/update-quotation-status/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ quotation_status: "Sent" }),
      });

      if (statusRes.ok) {
        setQuotationStatus("Sent");
        alert("Quotation sent & status updated to Sent!");
      } else {
        alert("Quotation sent but failed to update status.");
      }
    } catch (err) {
      console.error("Error sending quotation:", err);
      alert("Failed to send quotation. Please try again.");
    } finally {
      setSendingQuotation(false);
    }
  };

  if (!data || !leadInfo)
    return <p className="text-center mt-5 text-danger fw-bold">Loading quotation...</p>;

  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />

      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
        <div className="container my-4 mx-3">
          {/* Top Buttons */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <button
              className="btn btn-outline-secondary d-flex align-items-center shadow-sm"
              onClick={() => navigate(-1)}
            >
              <FiArrowLeft className="me-2" /> Back
            </button>

            {/* <div className="d-flex gap-2">
              <button
                className="btn btn-warning d-flex align-items-center shadow-sm"
                onClick={handlePDFPreview}
                disabled={quotationData.length === 0}
              >
                <FiFileText className="me-2" /> PDF Preview
              </button>
              {quotationStatus === "Approved" && quotationStatus !== "Sent" ? (
                <button
                  className="btn btn-success d-flex align-items-center shadow-sm"
                  onClick={handleGenerateQuotation}
                  disabled={quotationData.length === 0 || sendingQuotation}
                >
                  {sendingQuotation ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-1" />
                      Sending...
                    </>
                  ) : (
                    <>
                      <FiSend className="me-1" />
                      Send Quotation
                    </>
                  )}
                </button>
              ) : quotationStatus === "Sent" ? (
                <span className="badge bg-success d-flex align-items-center px-3 py-2">
                  Sent 📩
                </span>
              ) : null}
            </div> */}
          </div>

          {/* Quotation Card */}
          <div className="card shadow-lg border-0 rounded-3">
            <div className="card-body p-4">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center border-bottom pb-3 mb-4">
                <div>
                  <h3 className="fw-bold text-primary mb-1">SBS Company</h3>
                  <p className="mb-0 small text-muted">123 Business Street, Commercial Area</p>
                  <p className="mb-0 small text-muted">Mumbai, Maharashtra - 400001</p>
                  <p className="mb-0 small text-muted">Phone: +91-9876543210</p>
                  <p className="mb-0 small text-muted">Email: contact@sbs.com</p>
                </div>
                <div className="text-end">
                  <h4 className="fw-bold text-dark">QUOTATION</h4>
                  <p className="mb-1"><strong>No:</strong> {leadInfo.quotation_number}</p>
               <p className="mb-0">
  <strong>Date:</strong>{" "}
  {(() => {
    const d = new Date(data.quotationDate);
    return `${d.getDate().toString().padStart(2, "0")}-${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${d.getFullYear()}`;
  })()}
</p>


                </div>
              </div>

              {/* Bill To */}
              <div className="border rounded p-3 bg-light mb-4">
                <h6 className="fw-bold text-secondary mb-2">Bill To:</h6>
                <p className="mb-1 fw-semibold">{leadInfo.lead_name}</p>
                <p className="mb-1 small">{leadInfo.email}</p>
                <p className="mb-1 small">{leadInfo.contact_number}</p>
                <p className="mb-0 small text-muted">Lead Source: {leadInfo.lead_source}</p>
              </div>

              {/* Table */}
              <div className="table-responsive">
                <table className="table table-bordered align-middle text-center">
                  <thead className="table-primary">
                    <tr>
                      <th>Product</th>
                      <th>HSN</th>
                      <th>Quantity</th>
                      <th>Unit Price</th>
                      <th>GST %</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(quotationData) && quotationData.length > 0 ? (
                      quotationData.map((item, index) => {
                        const qty = parseInt(item.quantity) || 0;
                        const price = parseFloat(item.listprice) || 0;
                        const gstRate = parseFloat(item.gstrate) || 0;
                        const total = qty * price + (qty * price * gstRate) / 100;
                        return (
                          <tr key={index}>
                            <td>
                              {item.maincategory_name} <br />
                              {item.subcategory_name} <br />
                              {item.product_name} - {item.batch} <br />
                              Size: {item.size}
                            </td>
                            <td>{item.hsncode}</td>
                            <td>{item.quantity}</td>
                            <td>{formatCurrency(item.listprice)}</td>
                            <td>{item.gstrate}%</td>
                            <td className="fw-bold">{formatCurrency(total)}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center text-muted">
                          No products found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Summary */}
              <div className="row justify-content-end mt-4">
                <div className="col-md-5">
                  <ul className="list-group shadow-sm">
                    <li className="list-group-item d-flex justify-content-between">
                      <span>Subtotal:</span>
                      <strong>{formatCurrency(data.subtotal)}</strong>
                    </li>
                    <li className="list-group-item d-flex justify-content-between">
                      <span>Discount ({discountType}):</span>
                      <strong>
                        {discountType === "percentage"
                          ? `${discount}%`
                          : formatCurrency(discount)}
                      </strong>
                    </li>
                    <li className="list-group-item d-flex justify-content-between">
                      <span>GST:</span>
                      <strong>{formatCurrency(data.totalGST)}</strong>
                    </li>
                    <li className="list-group-item d-flex justify-content-between bg-light">
                      <span className="fw-bold">Grand Total:</span>
                      <strong className="text-success fs-5">
                        {formatCurrency(data.grandTotal)}
                      </strong>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Terms & Conditions */}
              <div className="mt-4">
                <h6 className="fw-bold text-secondary text-start">Terms & Conditions:</h6>
                <div className="text-start small">
                  {leadInfo.terms_conditions ? (
                    <div className="terms-conditions-list">
                      {leadInfo.terms_conditions
                        .split('\n')
                        .filter((line) => line.trim())
                        .map((line, idx) => (
                          <div key={idx} className="d-flex mb-1">
                            <span className="me-2 fw-medium text-primary" style={{ minWidth: '20px' }}>
                              {idx + 1}.
                            </span>
                            <span>{line.trim()}</span>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <p className="text-muted">As per company policy.</p>
                  )}
                </div>
              </div>

              {/* Footer */}
              <div className="text-center mt-5 pt-3 border-top">
                <p className="mb-0 fw-semibold">Authorized Signature</p>
                <p className="mb-0 text-muted small">
                  Thank you for your business!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
  );
};

export default Previewquotationpage;
